import ReactDOM from 'react-dom';
const DocumentHead = ({
  head,
  children
}) => {
  return /*#__PURE__*/ReactDOM.createPortal(children, head);
};
DocumentHead.defaultProps = {
  head: document.head
};
export default DocumentHead;